export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Skye AI",
  "legalName": "Skye AI LLC",
  "url": "https://skyeai.io",
  "logo": "https://skyeai.io/skye-logo-hero.png",
  "description": "Skye AI builds custom AI systems for businesses — voice agents, chatbots, follow-up automation, and workflow buildouts. Done for you, managed by our team.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Fort Lauderdale",
    "addressRegion": "FL",
    "addressCountry": "US"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "email": "info@skyeai.io",
    "contactType": "customer service"
  },
  "sameAs": []
};

export const SOFTWARE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Skye AI",
  "applicationCategory": "BusinessApplication",
  "operatingSystem": "Web",
  "description": "Custom AI buildouts for businesses — voice agents, chatbots, lead follow-up, appointment booking, and workflow automation. Built and managed by a dedicated team.",
  "creator": {
    "@type": "Organization",
    "name": "Skye AI LLC"
  }
};

export const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is Skye AI?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Skye AI builds custom AI systems for businesses — voice agents, chatbots, automated follow-up, appointment booking, and workflow automation. Everything is done for you and managed by our dedicated team."
      }
    },
    {
      "@type": "Question",
      "name": "How does Skye AI work?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We start with a free Growth Planning Call to understand your business needs. Then our team builds custom AI voice agents, chatbots, follow-up sequences, and automations tailored to your operations — live within 30 days."
      }
    },
    {
      "@type": "Question",
      "name": "What types of businesses use Skye AI?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Any business that handles leads, appointments, customer communication, or repetitive workflows. From service businesses to agencies to e-commerce — if you need AI to scale operations, we can build it."
      }
    },
    {
      "@type": "Question",
      "name": "How fast will I see results?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most clients go live within 30 days. AI voice agents and chatbots start handling calls and messages immediately after launch, with automated follow-up running 24/7."
      }
    },
    {
      "@type": "Question",
      "name": "Do I need to do anything technical?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Not a thing. Your dedicated team handles everything — AI buildout, CRM integrations, workflow setup, and ongoing management. You just use the systems we build for you."
      }
    }
  ]
};

export const PAGE_SEO = {
  home: {
    title: 'Custom AI Buildouts for Business | Voice Agents, Chatbots & Automation',
    description: 'Skye AI builds custom AI systems for businesses — voice agents, chatbots, lead follow-up, appointment booking, and workflow automation. Done for you. Live in 30 days.',
    keywords: 'custom AI buildouts, AI voice agents, business automation, AI chatbots, workflow automation, lead follow-up AI, appointment booking AI, custom AI systems',
    path: '/',
  },
  features: {
    title: 'Features | AI Voice Agents, Chatbots & Workflow Automation',
    description: 'See how Skye AI automates your business: custom voice agents, AI chatbots, smart follow-up, appointment booking, workflow automation, and CRM integration.',
    keywords: 'AI features, voice agents, chatbot features, workflow automation, CRM integration, appointment booking AI',
    path: '/features',
  },
  workflows: {
    title: 'AI Workflows for Business Automation',
    description: 'See how Skye AI automates your entire pipeline — from lead capture and AI follow-up to appointment booking and workflow automation.',
    keywords: 'AI workflows, business automation, lead follow-up, appointment booking AI, workflow automation',
    path: '/workflows',
  },
  howItWorks: {
    title: 'How It Works | Live in 30 Days or Less',
    description: 'From your free Growth Planning Call to live AI systems in 30 days. See the step-by-step process for launching custom AI buildouts for your business.',
    keywords: 'how Skye AI works, custom AI setup, AI buildout process, done for you AI',
    path: '/how-it-works',
  },
  blog: {
    title: 'Blog | AI Growth Tips & Business Automation Insights',
    description: 'AI insights, business growth tips, and automation strategies from the Skye AI team. Learn how to scale with custom AI voice agents, chatbots, and workflows.',
    keywords: 'AI blog, business automation tips, AI voice agents, chatbot strategies, workflow automation',
    path: '/blog',
  },
  caseStudies: {
    title: 'Case Studies | $987K+ Revenue Generated for Businesses',
    description: 'See real results from businesses using custom AI systems built by Skye AI. Voice agents, chatbots, and automation driving real revenue.',
    keywords: 'AI case studies, business automation results, AI ROI, custom AI success stories',
    path: '/case-studies',
  },
  quiz: {
    title: 'Book Your AI Growth Planning Call',
    description: 'Book a free Growth Planning Call and discover how custom AI buildouts can scale your business. Voice agents, chatbots, automation, and more.',
    keywords: 'AI growth planning call, business consultation, custom AI consultation',
    path: '/quiz',
  },
  privacyPolicy: {
    title: 'Privacy Policy',
    description: 'Skye AI LLC Privacy Policy. Learn how we collect, use, and protect your personal information.',
    keywords: 'Skye AI privacy policy, data privacy, information security',
    path: '/privacy-policy',
  },
};
